<div class="top-section">
    <div class="flex items-center">
        <app-svg name="hamburger" class="common-hamburger" (click)="ss.toggleSidebar()" role="button"
            [color]="ss.theme().color8" *ngIf="!cc.isNarrowScreen()"></app-svg>
        <h4 class="heading mb-0">{{ ss.t('common_support') }}</h4>
    </div>
    <div class="flex items-center gap-6">
        <app-notification [iconColor]="cc.isNarrowScreen() ? ss.theme().color12 : null"></app-notification>
        <app-svg name="info" class="more-icon" role="button" (click)="openInstructions()" [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
        <app-svg name="close" role="button" (click)="navigateToToday()"
            [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
    </div>
</div>
<div class="body-section ri-p-4" #scrollContainer style="overflow-y: auto;">
    <div *ngIf="groupedMessages().length > 0">
        <ng-container *ngFor="let group of groupedMessages()">
            <div class="message-group" *ngIf="group.messages.length > 0">
                <p class="text-12-400 color-7 mb-0 ri-pb-2 text-center">{{ getGroupDateLabel(group.date) }}</p>
                <div class="message-container" *ngFor="let message of group.messages" [ngClass]="[
                    message.source === 'support' ? 'support-message' : 'user-message',
                    uploadingMessageIds().includes(message.id) ? (failedMessageIds().has(message.id) ? 'not-sent' : 'sending') : ''
                ]">
                    <div class="attachment-container" *ngIf="getAttachments(message.attachments).length > 0">
                        <ng-container *ngFor="let attachment of getAttachments(message.attachments); let i = index">
                            <div class="attachment" [ngClass]="message.source === 'support' ? 'support-message' : 'user-message'" (click)="viewAttachments(i, message, attachment)" role="button">
                                <img *ngIf="attachment.fileType === 'image' && imagesRecord()[attachment.id]" [src]="imagesRecord()[attachment.id]" alt="Attachment">
                                <app-loader *ngIf="attachment.fileType === 'image' && !imagesRecord()[attachment.id]" [noBackdrop]="true" [noBackdropShadow]="true" [color]="'color12'"></app-loader>
                                <app-svg *ngIf="attachment.fileType === 'txt' && attachment.originalFileName?.includes('LOG')" name="logFile" [color]="ss.theme().color12"></app-svg>
                                <app-svg *ngIf="attachment.fileType === 'txt' && !attachment.originalFileName?.includes('LOG')" name="document" [color]="ss.theme().color12"></app-svg>
                                <app-svg *ngIf="attachment.fileType === 'document'" name="document" [color]="ss.theme().color12"></app-svg>
                                <app-svg *ngIf="attachment.fileType === 'video'" name="play" [color]="ss.theme().color12"></app-svg>
                                <app-svg *ngIf="attachment.fileType === 'audio'" name="audio" [color]="ss.theme().color12"></app-svg>
                            </div>
                        </ng-container>
                    </div>
                    <div class="message" *ngIf="message.text">
                        <p class="text-14-400 color-12 mb-0">{{ message.text }}</p>
                    </div>
                    <div class="status-text ri-pt-1">
                        <p class="text-12-400 color-7 mb-0 text-end" *ngIf="uploadingMessageIds().includes(message.id) && !failedMessageIds().has(message.id)">{{ ss.t('supportChat_messageSending') }}</p>
                        <p class="text-12-400 color-11 mb-0 text-end" *ngIf="failedMessageIds().has(message.id)">{{ ss.t('supportChat_messageNotSendContent') }}</p>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="no-result-block h-full flex items-center justify-center flex-col" *ngIf="groupedMessages().length === 0">
        <app-no-result-block [placeholder]="'supportChat_emptyScreenContent'" [imagePlaceholder]="'messagePlaceholder'" [showQuickGuide]="false"></app-no-result-block>
    </div>
    <div class="chat-addons" *ngIf="attachmentValues.length > 0">
        <app-attachment-list class="ri-pt-3" [attachments]="attachmentValues" [title]="ss.t('common_support')" (deleteEvent)="deleteAttachments($event)" [public]="true" [entityId]="messageForm.value.id" [entityName]="'chat'" [uid]="cc.user.uid"></app-attachment-list>
    </div>
</div>
<div class="bottom-section">
    <div class="chat-input-bar">
        <div class="chat-input-container">
            <app-input-file [attachments]="newAttachments" [multiple]="true" [withLogs]="true" (sendLogs)="sendLogs($event)"></app-input-file>
            <app-input-text [control]="messageFc()" name="supportMessage" [placeholder]="ss.t('supportChat_textFieldPlaceholder')" [hideIcon]="true" maxLength="640" [noEnter]="true" class="w-full" (enter)="sendMessage()"></app-input-text>
            @if (messageFc().value?.trim() || attachmentValues.length > 0) {
                <button class="send-btn" (click)="sendMessage()">
                    <app-svg name="send" class="icon-mirror-rtl" [color]="ss.theme().color12" width="20px" height="20px"></app-svg>
                </button>
            }
        </div>
    </div>
</div>
